module.exports = __webpack_public_path__ + "img/tips_photo.b50fa242.png";